import React, { useState, useRef } from 'react';
import './become-a-dealer.css';
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css';
import emailjs from '@emailjs/browser';


const BecomeADealer = () => {
    const [formData, setFormData] = useState({
        companyName: '',
        contactPerson: '',
        positionInCompany: '',
        phoneNo: '',
        email: '',
        companyWebsite: '',
        companyAddress: '',
        city: '',
        country: '',
        postCode: '',
        productsDealingIn: '',
        establishedSince: '',
        businessType: {
            retailer: false,
            manufacturerRetailer: false,
            manufacturerTrade: false,
            other: false,
            otherValue: ''
        },
        message: ''
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setFormData(prev => ({
                ...prev,
                businessType: {
                    ...prev.businessType,
                    [name]: checked
                }
            }));
        } else if (name === 'otherValue') {
            setFormData(prev => ({
                ...prev,
                businessType: {
                    ...prev.businessType,
                    otherValue: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const [phone, setPhone] = useState("");

    const formRef = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            process.env.REACT_APP_EMAIL_SERVICES_KEY_DEALER_FROM,
            process.env.REACT_APP_EMAIL_TEMPLATE_ID_DEALER_FROM,
            formRef.current,
            process.env.REACT_APP_EMAIL_PUBLIC_KEY_DEALER_FROM
        ).then(
            (result) => {
                alert("Message sent successfully!");
            },
            (error) => {
                alert("Something went wrong. Please try again.");
                console.error(error);
            }
        );
    };



    return (
        <div className="dealer-FromPage">
            <div className="dealer-form-container">
                <div className="Page-Main_Dec">
                    <h1 className="Page-title_LowerCase">Become A Dealer</h1>
                    <p className="Sep-subtitle">If you wish to become a Callistus Dealer, please fill out the first-hand information as requested below.</p>
                </div>

                <form ref={formRef} onSubmit={sendEmail}>
                    {/* Row 1 - Company Name */}
                    <div className="form-group">
                        <label htmlFor="companyName">Company Name*</label>
                        <input
                            type="text"
                            id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Row 2 - Contact Person */}
                    <div className="form-group">
                        <label htmlFor="contactPerson">Contact Person*</label>
                        <input
                            type="text"
                            id="contactPerson"
                            name="contactPerson"
                            value={formData.contactPerson}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Row 3 - Position in Company */}
                    <div className="form-group">
                        <label htmlFor="positionInCompany">Position in Company*</label>
                        <input
                            type="text"
                            id="positionInCompany"
                            name="positionInCompany"
                            value={formData.positionInCompany}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Row 4 - Three columns */}
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="phoneNo">Phone No.*</label>
                            <PhoneInput
                                country={""}
                                enableSearch={true}
                                value={phone}
                                onChange={(phone) => setPhone(phone)}
                                placeholder=""
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email*</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="companyWebsite">Company Website</label>
                            <input
                                type="url"
                                id="companyWebsite"
                                name="companyWebsite"
                                value={formData.companyWebsite}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Row 5 - Company Address */}
                    <div className="form-group">
                        <label htmlFor="companyAddress">Company Address*</label>
                        <input
                            type="text"
                            id="companyAddress"
                            name="companyAddress"
                            value={formData.companyAddress}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    {/* Row 6 - Three columns */}
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="city">City*</label>
                            <input
                                type="text"
                                id="city"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="country">Country*</label>
                            <input
                                type="text"
                                id="country"
                                name="country"
                                value={formData.country}
                                onChange={handleChange}
                                required
                            />

                        </div>

                        <div className="form-group">
                            <label htmlFor="postCode">Post Code*</label>
                            <input
                                type="text"
                                id="postCode"
                                name="postCode"
                                value={formData.postCode}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    {/* Row 7 - Two fields */}
                    <div className="form-row">
                        <div className="form-group">
                            <label htmlFor="productsDealingIn">Products dealing in</label>
                            <input
                                type="text"
                                id="productsDealingIn"
                                name="productsDealingIn"
                                value={formData.productsDealingIn}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="establishedSince">Established Since</label>
                            <input
                                type="text"
                                id="establishedSince"
                                name="establishedSince"
                                value={formData.establishedSince}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* Row 8 - Business Type label */}
                    <div className="form-group">
                        <label>Business Type*</label>
                    </div>

                    {/* Row 9 - Checkbox options */}
                    <div className="form-group checkbox-group">
                        <div className="checkbox-option">
                            <input
                                type="checkbox"
                                id="retailer"
                                name="retailer"
                                checked={formData.businessType.retailer}
                                onChange={handleChange}
                            />
                            <label htmlFor="retailer">Retailer Retail Storefront</label>
                        </div>

                        <div className="checkbox-option">
                            <input
                                type="checkbox"
                                id="manufacturerRetailer"
                                name="manufacturerRetailer"
                                checked={formData.businessType.manufacturerRetailer}
                                onChange={handleChange}
                            />
                            <label htmlFor="manufacturerRetailer">Manufacturing Retailer / Franchise</label>
                        </div>

                        <div className="checkbox-option">
                            <input
                                type="checkbox"
                                id="manufacturerTrade"
                                name="manufacturerTrade"
                                checked={formData.businessType.manufacturerTrade}
                                onChange={handleChange}
                            />
                            <label htmlFor="manufacturerTrade">Manufacturing Trade / Trader / Distributor</label>
                        </div>

                        <div className="checkbox-option">
                            <input
                                type="checkbox"
                                id="other"
                                name="other"
                                checked={formData.businessType.other}
                                onChange={handleChange}
                            />
                            <label htmlFor="other">Other</label>
                        </div>
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="otherValue"
                            value={formData.businessType.otherValue}
                            onChange={handleChange}
                            className="other-input"
                        />
                    </div>

                    {/* Row 10 - Message */}
                    <div className="form-group message-field">
                        <label htmlFor="message">Message</label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>

                    {/* Row 11 - Submit button */}
                    <button type="submit" className="submit-btn">Submit</button>
                </form>
            </div>
        </div>
    );
};

export default BecomeADealer;